<template>
  <UButton variant="ghost" data-cy="auth-button"
           :class="['p-0 hover:opacity-80 hover:bg-transparent hover:cursor-pointer active:bg-transparent focus:bg-transparent group', textClass]"
           @click="uiStore.isAuthModalOpen = true">
    <UIcon name="ph:user" class="w-5 h-5 block group-hover:hidden group-focus:hidden group-active:hidden"/>
    <UIcon name="ph:user-fill" class="w-5 h-5 hidden group-hover:block group-focus:block group-active:block"/>
    <span>Entrar/Cadastrar</span>
  </UButton>
</template>
<script setup lang="ts">
import {useUiStore} from '~/stores/useUiStore'
const uiStore = useUiStore()

const props = defineProps<{
  textClass?: string
}>()
</script>